import React, { useContext, useEffect, useState } from "react";
import { ChatContext } from "../context/ChatContext";
import SideChatFeed from "./SideChatFeed";
import Searchbar from "./Searchbar";
import MessagesDashboard from "./MessagesDashboard";
// Carousel removed per request
import DashboardHome from "./DashboardHome";
import AsyncLocalStorage from '@createnextapp/async-local-storage';
import socket from "../services/socket";

const ChatDashboard = () => {
  const { data, dispatch } = useContext(ChatContext);
  const [currentChat, setCurrentChat] = useState(data.currentChat);
  const [searchText, setSearchText] = useState("");

  console.log('ChatDashboard rendering - activeChats:', data.activeChats, 'currentChat:', currentChat);

  useEffect(() => {
    setCurrentChat(data.currentChat);
  }, [data.currentChat]);

  const HandleSelect = async (chat) => {
    try {
      let client_id = await AsyncLocalStorage.getItem("silu-ClientId");
      if (client_id) {
        socket.emit("set-channel", { clientId: client_id, channelId: chat.channel_id });
      }

      dispatch({ type: "CHANGE_CHAT", payload: chat.channel_id });
      dispatch({ type: "SET_CATEGORY", payload: chat.category });
      dispatch({ type: "SET_CHAT", payload: chat });
      setCurrentChat(chat);
      dispatch({ type: "RESET_ACCOUNT_VIEW" });
    } catch (error) {
      console.error("Error selecting chat:", error);
    }
  };

  return (
    <main className="flex flex-1 h-screen bg-gradient-to-br from-sky-100 via-white to-neutral-200">
      <aside className="md:order-first lg:order-first lg:block lg:flex-shrink-0 bg-sidebar border-r border-gray-200 shadow-lg">
        <div className="relative flex h-screen w-full md:w-96 flex-col">
          <div className="px-4 py-2 flex-shrink-0 border-b border-gray-200">
            <div className="flex items-center justify-between mb-1">
              <h2 className="text-lg font-semibold text-gray-800">CRM Chat</h2>
            </div>
            {/* Search moved into chat header (compact spacing) */}
            <div className="mt-1">
              <Searchbar filterSearch={(val) => setSearchText(val)} />
            </div>
          </div>
          <div className="flex-1 overflow-hidden">
            <SideChatFeed searchText={searchText} />
          </div>
        </div>
      </aside>
      {data.channelId == "null" || !currentChat?.channel_id || currentChat?.channel_id === 0 ? (
        <DashboardHome />
      ) : (
        <MessagesDashboard />
      )}
    </main>
  );
};

export default ChatDashboard;
